import React from "react";
import {
  Container,
  FlexRowWrapper,
  FlexWrapper,
  Text1,
  Text2,
  Text3,
  Text4,
  Text4_5,
  Text5,
  Text6,
} from "../../Components/Common";
import Navbar from "../../Components/Navbar/Navbar";
import TempeleteOne from "../../Components/Template/Templete1";
import { Heading } from "../../Components/Template/Templete1/style";
import {
  ExpandIcon,
  FAQPoints,
  ShopifyImage,
  ShopifyImageWrapper,
} from "../Home/Sections/SectionThree/style";
import { BottomImageWrapper, GifImage, HeroSectionWrapper, MainWrapper } from "./styles";
import ShopifyImageImage from "../../Assets/shopify.png";
import DownArrow from "../../Assets/down-arrow.png";
import WhoIsComponent from "../../Components/Template/WhoIsComponent";
import Footer from "../../Components/Footer/Footer";
import CustomGrid from "../../Components/CustomGrid";
import {
  BackgroundImageContainer,
  NumberText,
} from "../Home/Sections/SectionTwo/styles";
import ScrollAnimation from "react-animate-on-scroll";
import ImagePartnerMiddle from "../../Assets/bg/imgpartnermiddle.png";
import BottomImage from "../../Assets/bg/homepage-image2.png";
const PricingTwo = () => {
  return (
    <>
      <Navbar />
      <MainWrapper>
        {/* hero section */}
        <ScrollAnimation animateIn="fadeIn" duration={1.5} delay={100}>
          <HeroSectionWrapper>
            <Container width={"95%"}>
              <Text5 color={"rgba(255, 255, 255, 0.7)"}>
                Escribelo | Partners
              </Text5>
              <TempeleteOne
                heading1={"Ready To Promote The "}
                heading2={"Hottest New SaaS Tool?"}
                description={
                  "Show your audience the NEW way to create content and write copy using Jarvis. Give them a special offer, and when they sign up you'll get 30% recurring commission for life."
                }
                description2={""}
                ButtonTitle={"Apply to be a partner"}
                styles={{ margin: "0px auto", padding: "0px" }}
              />
              <FlexWrapper justify={"center"}>
                <Text6 color={"rgba(255, 255, 255, 0.7)"} margin={"0px"}>
                  Already a partner?
                </Text6>
                <Text6
                  color={"white"}
                  margin={"0px"}
                  weight={700}
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  Login to your dashboard
                </Text6>
              </FlexWrapper>
            </Container>
          </HeroSectionWrapper>
        </ScrollAnimation>
        {/* shopify section */}
        <ScrollAnimation animateIn="fadeIn" duration={1.5} delay={100}>
          <FlexWrapper
            direction={"column"}
            margin={"60px auto"}
            padding={"0px 5px "}
          >
            <Text3 color={"white"} weight={800}>
              See what other official Partners have to say <br /> about the
              program
            </Text3>
            <Container>
              <FlexRowWrapper
                wrap={"wrap"}
                justify={"space-around"}
                margin={"30px auto"}
              >
                {Array.from(Array(8).keys()).map((item, index) => (
                  <ShopifyImageWrapper key={index}>
                    <ShopifyImage src={ShopifyImageImage} />
                  </ShopifyImageWrapper>
                ))}
              </FlexRowWrapper>
            </Container>
          </FlexWrapper>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
          <Container>
            <CustomGrid />
          </Container>
        </ScrollAnimation>
        <Container>
          <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
            <FlexWrapper direction={"column"} margin={"20px auto"}>
              <Text4 color={"white"} weight={900} fontFamlily={"Inter"}>
                How the Affiliate Program works
              </Text4>
              <FlexWrapper direction={"row"} gap={"40px"} margin={"20px auto"}>
                <FlexWrapper direction={"column"}>
                  <NumberText color={"#06D9CA"} weight={800}>
                    {"1"}
                  </NumberText>
                  <Text4 color={"white"}>{"Get a unique link"}</Text4>
                  <Text6 color={"white"} weight={500}>
                    Jarvis is trained by copywriters and <br /> conversion
                    experts with rules to <br /> follow and models to mimic.
                  </Text6>
                </FlexWrapper>

                <FlexWrapper direction={"column"}>
                  <NumberText color={"#19B6F0"} weight={800}>
                    {"2"}
                  </NumberText>
                  <Text4 color={"white"}>{"Share a link"}</Text4>
                  <Text6 color={"white"} weight={500}>
                    Jarvis is trained by copywriters and <br /> conversion
                    experts with rules to <br /> follow and models to mimic.
                  </Text6>
                </FlexWrapper>

                <FlexWrapper direction={"column"}>
                  <NumberText color={"#6E6CFF"} weight={800}>
                    {"3"}
                  </NumberText>
                  <Text4 color={"white"}>{"Earn commision"}</Text4>
                  <Text6 color={"white"} weight={500}>
                    Jarvis is trained by copywriters and <br /> conversion
                    experts with rules to <br /> follow and models to mimic.{" "}
                  </Text6>
                </FlexWrapper>
              </FlexWrapper>
            </FlexWrapper>
          </ScrollAnimation>
        </Container>
        <BackgroundImageContainer backgroundUrl={ImagePartnerMiddle}>
          <FlexWrapper
            direction={"column"}
            gap={"50px"}
            align={"center"}
            padding={"80px 0px"}
          >
            {/* 1 */}
            <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
              <Container width={"80%"}>
                <FlexWrapper
                  gap={"30px"}
                  justify={"space-around"}
                  direction={"row"}
                  align={"center"}
                >
                  <Container width={"40%"} mobileWidth={"80%"} margin={"0px"}>
                    <FlexWrapper direction={"column"} width={"100%"}>
                      <Text2
                        color={"white"}
                        weight={700}
                        align={"left"}
                        margin={"8px 0px"}
                        fontFamily={"Inter"}
                      >
                        Share our proven
                        <br /> marketing swipe files
                      </Text2>
                      <Text5
                        color={"white"}
                        weight={600}
                        align={"left"}
                        margin={"8px 0px"}
                      >
                        Promoting Escribelo will be a breeze – we're giving you
                        the best social media post, emails, and marketing
                        material we used to grow Jarvis past 1000 paying
                        customers in 30 days. Your audience will thank you.
                      </Text5>
                    </FlexWrapper>
                  </Container>

                  <GifImage width={"40%"} justify={"center"} align={"center"}>
                    <Text2 color={"color"} weight={900}>
                      GIF
                    </Text2>
                  </GifImage>
                </FlexWrapper>
              </Container>
            </ScrollAnimation>
            {/* 2 */}
            <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
              <Container width={"80%"}>
                <FlexWrapper
                  gap={"30px"}
                  justify={"space-around"}
                  direction={"row-reverse"}
                  align={"center"}
                >
                  <Container width={"40%"} mobileWidth={"80%"} margin={"0px"}>
                    <FlexWrapper direction={"column"} width={"100%"}>
                      <Text2
                        color={"white"}
                        weight={700}
                        align={"left"}
                        margin={"8px 0px"}
                        fontFamily={"Inter"}
                      >
                        Give your referrals
                        <br /> 10,000 bonus word credits
                      </Text2>
                      <Text5
                        color={"white"}
                        weight={600}
                        align={"left"}
                        margin={"8px 0px"}
                      >
                        Hook up your audience with an amazing deal that's not
                        publically available. When they sign up through you,
                        they'll get 10,000 bonus credits added to their account
                      </Text5>
                    </FlexWrapper>
                  </Container>

                  <GifImage width={"40%"} justify={"center"} align={"center"}>
                    <Text2 color={"color"} weight={900}>
                      GIF
                    </Text2>
                  </GifImage>
                </FlexWrapper>
              </Container>
            </ScrollAnimation>
            {/* 3 */}
            <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
              <Container>
                <FlexWrapper
                  gap={"30px"}
                  justify={"space-around"}
                  direction={"row"}
                  align={"center"}
                >
                  <Container width={"40%"} mobileWidth={"80%"} margin={"0px"}>
                    <FlexWrapper direction={"column"} width={"100%"}>
                      <Text2
                        color={"white"}
                        weight={700}
                        align={"left"}
                        margin={"8px 0px"}
                        fontFamily={"Inter"}
                      >
                        Earn 30% recurring
                        <br /> monthly income for lifetime
                      </Text2>
                      <Text5
                        color={"white"}
                        weight={600}
                        align={"left"}
                        margin={"8px 0px"}
                      >
                        When someone who clicked on your link signs up within 30
                        days, we'll send you a PayPal for 30% commission every
                        month they renew their subscription. Depending on their
                        plan, you'll earn between $9/mo-$299/mo per customer for
                        life!
                      </Text5>
                    </FlexWrapper>
                  </Container>

                  <GifImage width={"40%"} justify={"center"} align={"center"}>
                    <Text2 color={"color"} weight={900}>
                      GIF
                    </Text2>
                  </GifImage>
                </FlexWrapper>
              </Container>
            </ScrollAnimation>
          </FlexWrapper>
        </BackgroundImageContainer>
        <BottomImageWrapper backgroundUrl={BottomImage}>
          <Container>
            <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
              <WhoIsComponent />
            </ScrollAnimation>
            <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
              <TempeleteOne
                heading1={"Boost Your Passive Income"}
                heading2={" Every Time You Refer Escribelo"}
                description={
                  "Your friends, followers, and clients will get 10,000 bonus credits when they sign up with your link and you'll get 30% commission for life."
                }
                ButtonTitle={"Become a partner"}
                styles={{ margin: "0px auto", padding: "0px" }}
              />
            </ScrollAnimation>
          </Container>

          {/* Question about */}
          <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
            <Container>
              <FlexWrapper direction={"column"} margin={"30px auto"}>
                <Text3
                  color={"white"}
                  weight={900}
                  margin={"30px auto"}
                  fontFamily={"Inter"}
                >
                  Questions about the Affiliate program?
                </Text3>
                <FlexWrapper
                  wrap={"wrap"}
                  gap={"30px"}
                  justify={"space-between"}
                >
                  <FAQPoints width={"45%"}>
                    <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                      What's the cost of Escribelo?
                    </Text4_5>
                    <ExpandIcon src={DownArrow} />
                  </FAQPoints>
                  <FAQPoints width={"45%"}>
                    <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                      What's the cost of Escribelo?
                    </Text4_5>
                    <ExpandIcon src={DownArrow} />
                  </FAQPoints>
                  <FAQPoints width={"45%"}>
                    <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                      What examples I can use Escribelo for?
                    </Text4_5>
                    <ExpandIcon src={DownArrow} />
                  </FAQPoints>
                  <FAQPoints width={"45%"}>
                    <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                      What examples I can use Escribelo for?
                    </Text4_5>
                    <ExpandIcon src={DownArrow} />
                  </FAQPoints>
                  <FAQPoints width={"45%"}>
                    <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                      What's the cost of Escribelo?
                    </Text4_5>
                    <ExpandIcon src={DownArrow} />
                  </FAQPoints>
                  <FAQPoints width={"45%"}>
                    <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                      What's the cost of Escribelo?
                    </Text4_5>
                    <ExpandIcon src={DownArrow} />
                  </FAQPoints>
                </FlexWrapper>
              </FlexWrapper>
            </Container>
          </ScrollAnimation>
        </BottomImageWrapper>

        <Footer />
      </MainWrapper>
    </>
  );
};

export default PricingTwo;
